/**
 *
 * Loader
 *
 */
import { ProgressCircle } from '@adobe/react-spectrum';
import React, { memo } from 'react';
import './index.scss';
interface Props {
  small?: boolean;
}

export const Loader = memo(({ small }: Props) => {
  return (
    <ProgressCircle
      aria-label="Loading…"
      isIndeterminate
      UNSAFE_className={small ? 'relative-loader' : 'center-loader'}
      data-testid="loader-progress-circle"
    />
  );
});
